module.exports = __webpack_public_path__ + "static/media/a2.12959e6c.jpg";